export const longLocationTypes = {
  'week': 'Semaine',
  'month': 'Mois',
  'year': 'Année'
};

// Day multiplicator
export const longLocationTypeMultiplicator = {
  'week': 7,
  'month': 30,
  'year': 365
};



// WEBPACK FOOTER //
// ./src/constants/LongLocationType.js